import * as React from 'react';
import { useState } from 'react';
import { Modal, Typography, Stack, Button, Box } from '@mui/material';
import ArrowRight from '../icons/ArrowRight';
import EduzinhoFigure from './EduzinhoFigure';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import LogoIsaac from '@/assets/images/logoIsaac.png';
import LogoEdu from '@/assets/images/LogoEdu.png';
import LogoKedu from '@/assets/images/LogoKedu.png';
import LogoEduBank from '@/assets/images/LogoeducBank.png';
import LogoClipSchool from '@/assets/images/clipEscola.png';
import LogoActiveSoft from '@/assets/images/Activesoft.png';
import LogoSophia from '@/assets/images/logoSophia.png';
import LogoSponte from '@/assets/images/sponte.png';
import Checkbox from '@mui/material/Checkbox';

type PropsType = {
  open: boolean;
  handleClose: () => void;
};

const FirstAccessModal: React.FC<PropsType> = ({ open, handleClose }) => {
  const [stepFirstAccess, setStepFirstAccess] = useState(1);

  const alignIcon = () => {
    switch (stepFirstAccess) {
      case 1:
      case 9:
        return 'center';
        break;
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 8:
        return 'end';
        break;
      default:
        return 'center';
    }
  };

  const alignButton = () => {
    switch (stepFirstAccess) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
        return 'center';
        break;
      case 7:
      case 8:
        return 'end';
        break;
      default:
        return 'center';
    }
  };

  const textBalon = () => {
    switch (stepFirstAccess) {
      case 1:
        return 'Bem vindo, eu sou Eduzinho e vou te ajudar no seu primeiro acesso.';
      case 2:
        return 'Quanto alunos estão matriculados nas suas instituições ao todo?';
      case 3:
        return 'Quantos professores ao todo, trabalham em suas instituições?';
      case 4:
        return 'Quantas turmas/séries existem ao todo em suas instituições?';
      case 5:
        return 'Quantas instituições você possui ao todo?';
      case 6:
        return 'Você utiliza algum sistema de inadimplência zero?';
      case 7:
        return 'Quais destes sistemas de inadimplência zero você utilizava?';
      case 8:
        return 'Pronto! Coletei tudo que preciso, agora precisamos que você importe seus dados para cá, mas antes preciso saber qual sistema você utilizava anteriormente:';
      case 9:
        return 'Selecione e integre seus sistemas, logo após você poderá concluir seu primeiro acesso!';
      default:
        return '';
    }
  };

  const returnContent = () => {
    switch (stepFirstAccess) {
      case 1:
        return null;
      case 2:
        return (
          <FormControl sx={{ color: 'black', position: 'absolute', left: '20px', top: '40%' }}>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="female"
              name="radio-buttons-group"
            >
              <FormControlLabel value="1-100" control={<Radio />} label="Entre 1 e 100" />
              <FormControlLabel value="101-200" control={<Radio />} label="Entre 101 e 200" />
              <FormControlLabel value="201-300" control={<Radio />} label="Entre 201 e 300" />
              <FormControlLabel value="301-400" control={<Radio />} label="Entre 301 e 400" />
            </RadioGroup>
          </FormControl>
        );
      case 3:
        return (
          <FormControl sx={{ color: 'black', position: 'absolute', left: '20px', top: '40%' }}>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="female"
              name="radio-buttons-group"
            >
              <FormControlLabel value="female" control={<Radio />} label="Entre 1 e 5" />
              <FormControlLabel value="male" control={<Radio />} label="Entre 5 e 10" />
              <FormControlLabel value="other" control={<Radio />} label="Entre 10 e 20" />
              <FormControlLabel value="other" control={<Radio />} label="Entre 20 e 50" />
              <FormControlLabel value="other" control={<Radio />} label="Entre 50 e 100" />
            </RadioGroup>
          </FormControl>
        );
      case 4:
        return (
          <FormControl sx={{ color: 'black', position: 'absolute', left: '20px', top: '40%' }}>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="female"
              name="radio-buttons-group"
            >
              <FormControlLabel value="female" control={<Radio />} label="Entre 1 e 5" />
              <FormControlLabel value="male" control={<Radio />} label="Entre 5 e 10" />
              <FormControlLabel value="other" control={<Radio />} label="Entre 10 e 20" />
              <FormControlLabel value="other" control={<Radio />} label="Entre 20 e 50" />
              <FormControlLabel value="other" control={<Radio />} label="Entre 50 e 100" />
            </RadioGroup>
          </FormControl>
        );
      case 5:
        return (
          <FormControl sx={{ color: 'black', position: 'absolute', left: '20px', top: '40%' }}>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="female"
              name="radio-buttons-group"
            >
              <FormControlLabel value="female" control={<Radio />} label="Entre 1 e 3" />
              <FormControlLabel value="male" control={<Radio />} label="Entre 4 e 6" />
              <FormControlLabel value="other" control={<Radio />} label="Entre 7 e 9" />
              <FormControlLabel value="other" control={<Radio />} label="Entre 11 e 12" />
            </RadioGroup>
          </FormControl>
        );
      case 6:
        return (
          <FormControl sx={{ color: 'black', position: 'absolute', left: '20px', top: '40%' }}>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="female"
              name="radio-buttons-group"
            >
              <FormControlLabel value="yes" control={<Radio />} label="Sim" />
              <FormControlLabel value="no" control={<Radio />} label="Não" />
            </RadioGroup>
          </FormControl>
        );
      case 7:
        return (
          <FormControl sx={{ color: 'black', position: 'absolute', left: '20px', top: '40%' }}>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="female"
              name="radio-buttons-group"
            >
              <FormControlLabel
                value="isaac"
                control={<Checkbox />}
                label={<img style={{ width: '65px' }} src={LogoIsaac} alt="" />}
              />
              <FormControlLabel
                value="kedu"
                control={<Checkbox />}
                sx={{ backgroundColor: 'transparent' }}
                label={
                  <img
                    src={LogoKedu}
                    alt="Kedu"
                    style={{
                      width: '115px',
                      backgroundColor: '#2968A3',
                      borderRadius: '4px',
                      padding: '2px 6px',
                      display: 'block',
                    }}
                  />
                }
              />
              <FormControlLabel
                value="eduBank"
                control={<Checkbox />}
                label={<img style={{ width: '120px' }} src={LogoEduBank} alt="" />}
              />
              {/* <FormControlLabel
                value="clipSchool"
                control={<Checkbox />}
                label={<img style={{ width: '122px' }} src={LogoClipSchool} alt="" />}
              /> */}
            </RadioGroup>
          </FormControl>
        );
      case 8:
        return (
          <FormControl sx={{ color: 'black', position: 'absolute', left: '20px', top: '40%' }}>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="female"
              name="radio-buttons-group"
            >
              {/* <FormControlLabel
                value="other"
                control={<Radio />}
                label={<img style={{ width: '65px' }} src={LogoIsaac} alt="" />}
              /> */}
              <FormControlLabel
                value="other"
                control={<Radio />}
                label={<img style={{ width: '115px' }} src={LogoActiveSoft} alt="" />}
              />
              <FormControlLabel
                value="other"
                control={<Radio />}
                label={<img style={{ width: '120px' }} src={LogoSophia} alt="" />}
              />
              <FormControlLabel
                value="other"
                control={<Radio />}
                label={<img style={{ width: '95px' }} src={LogoSponte} alt="" />}
              />
            </RadioGroup>
          </FormControl>
        );
      default:
        return null;
    }
  };

  const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: stepFirstAccess === 9 ? '920px' : '517px',
    width: '100%',
    bgcolor: '#fff',
    borderRadius: '20px',
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Box style={{ background: '#93DC3F', borderRadius: '20px 20px 0 0', boxShadow: '0px 4px 4px 0px #00000040' }}>
            <Typography color={'#231F20'} variant="h1" p={'10px 29px'}>
              {stepFirstAccess === 9 ? 'Integrações' : 'Primeiro acesso'}
            </Typography>
          </Box>
          <Stack sx={{ p: '20px 30px 50px 30px' }} justifyContent={'center'} alignItems={alignButton()}>
            <Box>
              {stepFirstAccess === 9 ? (
                <Box sx={{ display: 'flex' }}>
                  <EduzinhoFigure message={textBalon()} position={alignIcon()} content={returnContent()} />
                  <Stack alignItems={'center'}>
                    <Stack flexDirection={'row'} color={'black'} gap={'10px'} sx={{ display: 'flex', ml: '30px' }}>
                      <Stack
                        sx={{ boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.15)' }}
                        alignItems={'center'}
                        height={'190px'}
                        border={'1px solid rgba(224, 221, 221, 1)'}
                        justifyContent={'space-between'}
                        >
                          <div style={{padding: '40px 40px 0 40px'}}>
                            <img style={{ width: '85px' }} src={LogoActiveSoft} alt="" />
                          </div>
                          <Stack alignItems={'center'} sx={{ width: '100%', height: '100%', justifyContent: 'end'}}>
                            <div style={{width: '100%', display: 'flex', justifyContent: 'center', flexDirection: 'column'}}>
                              <Typography sx={{ fontWeight: '700', display: 'flex', justifyContent: 'center', marginBottom: '4px'}}>ActiveSoft</Typography>
                              <Typography sx={{ border: '0.5px solid #E0DDDD', width: '100%' }}></Typography>
                              <div style={{
                                height: '100%',
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'end',
                                padding: '3px 10px 6px'
                              }}>
                                <Button
                                  sx={{ width: '100%', borderRadius: '24px', fontSize: '12px' }}
                                  variant="contained"
                                  style={{
                                    background: '#15AB51',
                                    textTransform: 'capitalize',
                                    height: '24px',
                                    padding: '0 !important'
                                  }}
                                >
                                  Integrar
                                </Button>
                              </div>
                            </div>
                        </Stack>
                      </Stack>
                      <Stack
                        sx={{ boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.15)' }}
                        alignItems={'center'}
                        height={'190px'}
                        border={'1px solid rgba(224, 221, 221, 1)'}
                        justifyContent={'space-between'}
                        >
                          <div style={{padding: '40px 40px 0 40px'}}>
                            <img style={{ width: '85px' }} src={LogoSophia} alt="" />
                          </div>
                          <Stack alignItems={'center'} sx={{ width: '100%', height: '100%', justifyContent: 'end'}}>
                            <div style={{width: '100%', display: 'flex', justifyContent: 'center', flexDirection: 'column'}}>
                              <Typography sx={{ fontWeight: '700', display: 'flex', justifyContent: 'center', marginBottom: '4px'}}>Sophia</Typography>
                              <Typography sx={{ border: '0.5px solid #E0DDDD', width: '100%' }}></Typography>
                              <div style={{
                                height: '100%',
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'end',
                                padding: '3px 10px 6px'
                              }}>
                                <Button
                                  sx={{ width: '100%', borderRadius: '24px', fontSize: '12px' }}
                                  variant="contained"
                                  style={{
                                    background: '#15AB51',
                                    textTransform: 'capitalize',
                                    height: '24px',
                                    padding: '0 !important'
                                  }}
                                >
                                  Integrar
                                </Button>
                              </div>
                            </div>
                        </Stack>
                      </Stack>
                      <Stack
                        sx={{ boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.15)' }}
                        alignItems={'center'}
                        height={'190px'}
                        border={'1px solid rgba(224, 221, 221, 1)'}
                        justifyContent={'space-between'}
                        >
                          <div style={{padding: '40px 40px 0 40px'}}>
                            <img style={{ width: '85px' }} src={LogoSponte} alt="" />
                          </div>
                          <Stack alignItems={'center'} sx={{ width: '100%', height: '100%', justifyContent: 'end'}}>
                            <div style={{width: '100%', display: 'flex', justifyContent: 'center', flexDirection: 'column'}}>
                              <Typography sx={{ fontWeight: '700', display: 'flex', justifyContent: 'center', marginBottom: '4px'}}>Sponte</Typography>
                              <Typography sx={{ border: '0.5px solid #E0DDDD', width: '100%' }}></Typography>
                              <div style={{
                                height: '100%',
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'end',
                                padding: '3px 10px 6px'
                              }}>
                                <Button
                                  sx={{ width: '100%', borderRadius: '24px', fontSize: '12px' }}
                                  variant="contained"
                                  style={{
                                    background: '#15AB51',
                                    textTransform: 'capitalize',
                                    height: '24px',
                                    padding: '0 !important'
                                  }}
                                >
                                  Integrar
                                </Button>
                              </div>
                            </div>
                        </Stack>
                      </Stack>
                    </Stack>

                    <Button
                      sx={{
                        width: '197px',
                        p: '10px 15px',
                        borderRadius: '24px',
                        fontSize: '14px',
                        mt: '40px',
                        bgcolor: '#15AB51',
                        '&:hover': {
                          bgcolor: '#ceface',
                          color: '#000',
                          border: '1px solid #15AB51'
                        },
                        textTransform: 'capitalize'
                      }}
                      variant="contained"
                      onClick={handleClose}
                    >
                      Finalizar
                      <ArrowRight style={{ marginLeft: '10px' }} />
                    </Button>
                  </Stack>
                </Box>
              ) : (
                <EduzinhoFigure message={textBalon()} position={alignIcon()} content={returnContent()} />
              )}
            </Box>
            {stepFirstAccess !== 9 && (
              <Button
                sx={{
                  maxWidth: '200px',
                  p: '15.5px 50px',
                  borderRadius: '24px',
                  fontSize: '14px',
                  mt: '60px',
                  bgcolor: '#15AB51',
                  textTransform: 'none',
                  fontWeight: 700,

                  '&:hover': {
                    bgcolor: '#ceface',
                    color: '#000',
                    border: '1px solid #15AB51',
                  },
                }}
                variant="contained"
                onClick={() => setStepFirstAccess(stepFirstAccess + 1)}
              >
                Continue
                <ArrowRight style={{ marginLeft: '10px' }} />
              </Button>
            )}
          </Stack>
        </Box>
      </Modal>
    </div>
  );
};

export default FirstAccessModal;
